import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { DiseaseFilterSettingsModel } from "../../../models/disease/diseaseFilterSettingsModel";
import AlphabeticalFilter from '../../../common/components/alphabeticalFilter/alphabeticalFilter';

interface IProps {
    onSearchClick: any,
    totalRecordsCount: number
}

interface IState {
    diseaseSettings: DiseaseFilterSettingsModel,
    selectedType: null,
    selectedGroup: null,
    filterText: string
}

export class DiseaseFilter extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props);
        this.state = {
            diseaseSettings: new DiseaseFilterSettingsModel(),
            selectedType: null,
            selectedGroup: null,
            filterText: ''
        };
    }

    handleAlphaIndexChange = (letter: string) => {
        const currentSettings: DiseaseFilterSettingsModel = { ...this.state.diseaseSettings };
        currentSettings.diseaseName = '';
        currentSettings.alphaIndex = letter;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            diseaseSettings: { ...currentSettings },
            filterText: fiterText
        });
        this.handleSearchButtonClick(currentSettings);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentSettings: DiseaseFilterSettingsModel = { ...this.state.diseaseSettings };
        currentSettings[name] = value;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            diseaseSettings: { ...currentSettings },
            filterText: fiterText
        });
    }

    generateFilterText = (settings: DiseaseFilterSettingsModel) => {
        let result = '';

        if (settings.alphaIndex) {
            result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
        }
        if (settings.diseaseName) {
            result += "Name <strong>'" + settings.diseaseName + "'</strong>, "
        }
        if (settings.diseaseCode) {
            result += "Code <strong>'" + settings.diseaseCode + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = (settings) => {
        this.props.onSearchClick(settings);
    }

    handleClearButtonClick = () => {
        this.setState({
            diseaseSettings: new DiseaseFilterSettingsModel(),
            filterText: ''
        });
        this.handleSearchButtonClick(new DiseaseFilterSettingsModel());
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick(this.state.diseaseSettings)
        }
    }

    render() {
        return (
            <Toolbar style={{ marginBottom: '10px' }}>
                <AlphabeticalFilter
                    handleAlphaIndexChange={this.handleAlphaIndexChange}
                    filters={['en', 'bg']}
                />
                <div>
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        name="diseaseName"
                        placeholder="Name"
                        onChange={this.handleChange}
                        value={this.state.diseaseSettings && this.state.diseaseSettings.diseaseName ? this.state.diseaseSettings.diseaseName : ''}
                    />
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        name="diseaseCode"
                        placeholder="Code"
                        onChange={this.handleChange}
                        value={this.state.diseaseSettings && this.state.diseaseSettings.diseaseCode ? this.state.diseaseSettings.diseaseCode : ''}
                    />
                </div>
                <div>
                    <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                        Result: <strong>{this.props.totalRecordsCount}</strong>
                        {this.state.filterText ? ', ' : ''}
                        <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                    </div>
                    <div style={{ float: "right" }}>
                        <div>
                            <Button
                                className="p-button-raised"
                                icon="pi pi-filter"
                                style={{ marginRight: "10px" }}
                                label="Filter"
                                onClick={() => this.handleSearchButtonClick(this.state.diseaseSettings)}
                            />
                            <Button
                                className="p-button-secondary p-button-raised"
                                label="Clear"
                                icon="pi pi-times"
                                onClick={() => this.handleClearButtonClick()}
                            />
                        </div>
                    </div>
                </div>
            </Toolbar>
        )
    }
}

export default DiseaseFilter;
